export default {
  ra0: 0,
  ra1: 2,
  ra2: 4,
  ra3: 6,
  ra4: 10,
  ra5: 16
};